import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

const MobileNotification = () => {
  const [isOpen, setIsOpen] = React.useState(true)
  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)} size='mini' style={{ top: '10rem', maxWidth: '370px', left: `${window.innerWidth / 2 - 185}px` }}>
      <Modal.Header>Device Compatibility</Modal.Header>
      <Modal.Content>
        <p>Your screen size or device type may not provide the best experience for this website. Sphero Central is best viewed on a desktop.</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setIsOpen(false)} primary>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default MobileNotification
